import React from 'react';
import classnames from 'classnames';
import { ListerProductData } from '../../../../../../types';
import ColorSwatches from '../../../colorSwatches/colorSwatches';
import PriceLine from './priceLine';
import Status from './status';
import descriptionStyles from './description.module.pcss';
import productsStyles from '../../products.module.pcss';
import IfcMessage from './ifcMessage';

interface DescriptionProps {
  product: ListerProductData;
  showColorSwatchPlaceholder: boolean;
  showIfcMessagePlaceholder: boolean;
}

function Description({
  showColorSwatchPlaceholder,
  showIfcMessagePlaceholder,
  product: {
    name,
    manufacturer,
    price,
    wasPrice,
    wasWasPrice,
    financingPromoMessage,
    productStatusOnListerPage,
    availableColorSwatches
  }
}: DescriptionProps): React.ReactElement {
  return (
    <div className={classnames(descriptionStyles.description, productsStyles.description)}>
      <Status productStatusOnListerPage={productStatusOnListerPage} />
      <h4
        className={classnames(descriptionStyles.description__brand, productsStyles.description__brand)}
        itemProp="brand"
      >
        {manufacturer}
      </h4>
      <h5 className={classnames(descriptionStyles.description__name, productsStyles.description__name)} itemProp="name">
        {name}
      </h5>
      <div className={descriptionStyles.separator} />
      <ColorSwatches showPlaceholder={showColorSwatchPlaceholder} availableColorSwatches={availableColorSwatches} />
      <PriceLine
        price={price}
        wasPrice={wasPrice}
        wasWasPrice={wasWasPrice}
        productStatusOnListerPage={productStatusOnListerPage}
      />
      <IfcMessage showPlaceholder={showIfcMessagePlaceholder} financingPromoMessage={financingPromoMessage} />
    </div>
  );
}

export default Description;
